import axios from 'axios';
import { APPX_SITE_API_URL } from '~/modules/config';
import { getPreferredLanguage } from '~/modules/helpers/languageHelper';
import { UserInfo } from '~/modules/services/userService';
import { getCookie } from '~/modules/utilities/cookies';
import { handleException } from '~/modules/utilities/error_utilities';

export async function isLoggedIn(): Promise<UserInfo | undefined> {
    let userInfo: UserInfo | undefined;
    try {
        const sid = getCookie('sid');
        const language = getPreferredLanguage();
        userInfo = await axios
            .post(`${APPX_SITE_API_URL}/auth`, {
                sid,
                language,
            })
            .then(({ data }) => data);
    } catch (error) {
        handleException(error, 'authService.isLoggedIn');
    }
    return userInfo;
}
